
import * as React from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts, removeToast } = useToast();
  
  console.log("Toaster rendering, toasts:", toasts);
  
  // Handle case where toasts might be undefined or null
  const safeToasts = Array.isArray(toasts) ? toasts : [];
  
  return (
    <ToastProvider>
      {safeToasts.map(({ id, title, description, type, variant }, index) => {
        const toastId = id || `toast-${index}`;
        const toastVariant = variant || (type === "error" ? "destructive" : "default");
        
        return (
          <Toast 
            key={toastId} 
            variant={toastVariant}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            <ToastClose onClick={() => removeToast(toastId)} />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
